import { AccountInfoWrapper, AccountUserNameWrapper } from "../../container/accountSettings.styles";

import React from "react";
import { FullNameTitle } from "../../../../styled";
import { HeaderUserFullNameWrapper, HeaderUserPosition, UserImageWrapper } from "../../../../Header/styled";

const AccountInfo = () => {
    const name = localStorage.getItem("name");
    const role = localStorage.getItem("user_role");

    return (
        <AccountInfoWrapper>
            <UserImageWrapper src={"/images/default.webp"} alt="User Image" />
            <AccountUserNameWrapper>
                <HeaderUserFullNameWrapper>
                    <FullNameTitle>{name} </FullNameTitle>
                    <HeaderUserPosition align="right">{role}</HeaderUserPosition>
                </HeaderUserFullNameWrapper>
            </AccountUserNameWrapper>
        </AccountInfoWrapper>
    );
};
export default AccountInfo;
